<template>
  <div class="arriendos-layout">

    <div class="arriendos-content">
      <h1>Contratos Vigentes</h1>
      <table>
        <thead>
          <tr>
            <th @click="fetchContratos(2)" style="cursor: pointer;">Fecha Aviso</th>
            <th @click="fetchContratos(3)" style="cursor: pointer;">Cuenta Depósito</th>
            <th @click="fetchContratos(4)" style="cursor: pointer;">Propiedad</th>
            <th>Arrendatario</th>
            <th>Tipo Contrato</th>
            <th>Monto Mensual</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contrato in contratosVigentes" :key="contrato.co_id">
            <td>{{ contrato.co_fecha_aviso }}</td>
            <td>{{ contrato.co_cuenta_deposito }}</td>
            <td>{{ contrato.pr_codigo }}</td>
            <td>{{ contrato.ar_nombre }}</td>
            <td>{{ contrato.co_tipo === 0 ? 'UF' : (contrato.co_tipo === 1 ? 'EE' : (contrato.co_tipo === 2 ? 'CLP' : contrato.co_tipo)) }}</td>
            <td style="text-align: right;">{{ formatMontoMensual(contrato) }}</td>
            <td style="text-align: right;">
              <router-link :to="`/arriendos/contratos/${contrato.co_id}/detalle`" class="btn btn-primary">Ver Detalle</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import apiClient from '../../api/index';

export default {
  name: 'ContratosVigentes',
  data() {
    return {
      contratosVigentes: []
    };
  },
  methods: {
    formatMontoMensual(contrato) {
      if (contrato.co_tipo === 2) {
        return 'CLP $' + Number(contrato.co_monto_clp).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      return parseFloat(contrato.co_monto_uf).toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' UF';
    },
    async fetchContratos(argument = 1) {
      try {
        const response = await apiClient.get(`/arriendos/contratos/vigentes-sp?argument=${argument}`);
        this.contratosVigentes = response.data;
      } catch (error) {
        console.error('Error fetching contratos vigentes:', error);
      }
    },
    goTo(name) {
      const routeMap = {
        'ContratosVigentes': { name: 'ContratosVigentes' },
        'Contratos': { name: 'Contratos' },
        'Pagos': { path: '/arriendos/pagos' },
        'Cobros': { path: '/arriendos/cobros' },
        'Propiedades': { path: '/arriendos/propiedades' },
      };
      this.$router.push(routeMap[name]);
    },
    isSelected(name) {
      if (name === 'ContratosVigentes') return this.$route.name === 'ContratosVigentes' || this.$route.path === '/arriendos';
      if (name === 'Contratos') return this.$route.name === 'Contratos';
      if (name === 'Pagos') return this.$route.path === '/arriendos/pagos';
      if (name === 'Cobros') return this.$route.path === '/arriendos/cobros';
      if (name === 'Propiedades') return this.$route.path === '/arriendos/propiedades';
      return false;
    }
  },
  mounted() {
    this.fetchContratos();
  }
};
</script>

<style scoped>
.arriendos-layout {
  display: flex;
  min-height: 100vh;
}
.arriendos-sidebar {
  width: 260px;
  min-width: 220px;
  background: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 1em 1em 1em;
  gap: 2em;
  height: 100vh;
  box-sizing: border-box;
}
.arriendos-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.arriendos-nav li {
  display: block;
  width: 100%;
}
.arriendos-content {
  margin-top: 1rem;
  flex: 1;
  padding: 2em 2em 2em 2em;
}
.button-71 {
  background-color: #0078d4;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 0.5px 1.5px rgba(0,0,0,0.08);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7em 1.5em;
  margin: 0.2em 0;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  outline: none;
  width: 100%;
  text-align: left;
  width:12em;
}
.button-71.selected {
  background-color: #22c55e !important;
  color: #fff;
  box-shadow: 0 4px 12px rgba(34,197,94,0.15);
  transform: scale(1.0);
}
.button-71:hover, .button-71:focus {
  background-color: #005fa3;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12), 0 1.5px 3px rgba(0,0,0,0.12);
  transform: translateY(-2px) scale(1.03);
}
.button-71:active {
  background-color: #004c87;
  box-shadow: 0 1px 2px rgba(0,0,0,0.10);
  transform: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.92em;
}

thead {
  background-color: #333; /* Darker background for header */
  color: #fff; /* White text for contrast */
}

tbody tr:nth-child(odd) {
  background-color: #f9f9f9; /* Light gray for odd rows */
}

tbody tr:nth-child(even) {
  background-color: #fff; /* White for even rows */
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 0.92em;
}

th {
  font-weight: bold;
}
</style>
